<section #liveCapacitySection class="web-parallax-bg">
  <div class="web-parallax-bg__bg">
    <img
      src="/assets/image/web-parallax-bg.webp"
      alt=""
      [style.transform]="'translate3d(0, ' + parallaxOffset + 'px, 0)'"
    />
  </div>

  <ng-content></ng-content>
</section>
